import React from "react";
import {
  Grid, GridItem, ClipboardCopy, Content, Tooltip
} from '@patternfly/react-core';
import { CONFIG } from '../../../../../config/config'
import { Icons } from 'shared/components/Icons/index'

const MountStorageInfoPrivate = ({
  context,
  nfs_exports,
  userProfile,
  iscsi_target
}) => {
  const smb_win_command = `net use Z: \\\\${CONFIG.SMB_IP}\\${userProfile.username} /user:${userProfile.username} *`
  const smb_win_command_public = `net use Z: \\\\${CONFIG.SMB_IP}\\public /user:${userProfile.username} *`
  const smb_lin_command = `mount -t cifs //${CONFIG.SMB_IP}/${userProfile.username} /mnt/${userProfile.username} -o username=${userProfile.username}`
  const smb_lin_command_public = `mount -t cifs //${CONFIG.SMB_IP}/public /mnt/public -o username=${userProfile.username}`
  // const code3 = `net use Z: \\\\sshfs\\${userProfile.username}@sftp.zspw.pl!222 /user:${userProfile.username} /persistent:no`
  const sshfs_win_wan_command = `net use Z: \\\\sshfs\\${userProfile.username}@sftp.zspw.pl!222 /user:${userProfile.username} *`
  const sshfs_win_lan_command = `net use Z: \\\\sshfs\\${userProfile.username}@${CONFIG.SMB_IP} /user:${userProfile.username} *`
  const sshfs_lin_wan_command = `sshfs ${userProfile.username}@sftp.zspw.pl:/data -p 222 /mnt/${userProfile.username}`
  const sshfs_lin_lan_command = `sshfs ${userProfile.username}@${CONFIG.SMB_IP}:/data /mnt/${userProfile.username}`

  const mount_command = (target_ip, pseude_path) => {
    return `mount -o vers=4.1 ${target_ip}:${pseude_path} /mnt/${pseude_path.trim().split("/").pop()}`
  }
  return (
    <>
      <br />
      <Grid
        hasGutter
        span={12}
        style={{
          fontSize: "13px",
          lineHeight: "1.6"
        }}
      >
        <>
          <GridItem span={12}>
            <Content component="h6">Montowanie udziałów prywatnych</Content>
            <table className="table">
              <tbody>
                <tr>
                  <th>OS</th>
                  <th>Sieć</th>
                  <th>Protokół</th>
                  <th style={{ textAlign: "right" }}>Polecenie montowania</th>
                </tr>
                {/* WIN */}
                <tr>
                  <td rowSpan={2}>
                    <Tooltip content={<div>Windows</div>}>
                      {Icons.Windows}
                    </Tooltip>
                  </td>
                  <td>LAN</td>
                  <td>SMB</td>
                  <td className="small">
                    <ClipboardCopy
                      copyAriaLabel="Copy inline compact example"
                      hoverTip="Kopiuj"
                      clickTip="Skopiowano"
                      variant="inline-compact"
                    >
                      {smb_win_command}
                    </ClipboardCopy>
                  </td>
                </tr>
                <tr>
                  <td>WAN</td>
                  <td>SSHFS</td>
                  <td className="small">
                    <ClipboardCopy
                      copyAriaLabel="Copy inline compact example"
                      hoverTip="Kopiuj"
                      clickTip="Skopiowano"
                      variant="inline-compact"
                    >
                      {sshfs_win_wan_command}
                    </ClipboardCopy>
                  </td>
                </tr>
                {/* LINUX */}
                <tr>
                  <td rowSpan={nfs_exports.length + 2}>
                    <Tooltip content={<div>Linux</div>}>
                      {Icons.Linux}
                    </Tooltip>
                  </td>
                  <td>LAN</td>
                  <td>SMB</td>
                  <td className="small">
                    <ClipboardCopy
                      copyAriaLabel="Copy inline compact example"
                      hoverTip="Kopiuj"
                      clickTip="Skopiowano"
                      variant="inline-compact"
                    >
                      {smb_lin_command}
                    </ClipboardCopy>
                  </td>
                </tr>
                <tr>
                  <td>WAN</td>
                  <td>SSHFS</td>
                  <td className="small">
                    <ClipboardCopy
                      copyAriaLabel="Copy inline compact example"
                      hoverTip="Kopiuj"
                      clickTip="Skopiowano"
                      variant="inline-compact"
                    >
                      {sshfs_lin_wan_command}
                    </ClipboardCopy>
                  </td>
                </tr>
                {nfs_exports.map((element, index) => (
                  // (userProfile.is_superuser || (context.state.isAuthUser && element.access_type !== "NONE")) && (
                  userProfile.is_superuser && (
                    <tr key={index}>
                      <td>LAN</td>
                      <td>NFS</td>
                      <td className="small">
                        <ClipboardCopy
                          copyAriaLabel="Copy inline compact example"
                          hoverTip="Kopiuj"
                          clickTip="Skopiowano"
                          variant="inline-compact"
                        >
                          {mount_command(iscsi_target?.portals[0]?.ip, element.pseudo)}
                        </ClipboardCopy>
                      </td>
                    </tr>
                  )
                ))}
              </tbody>
            </table>
          </GridItem>
        </>
      </Grid>
    </>
  );
};

export default MountStorageInfoPrivate;